<template>
  <ul class="car-meta-list">
    <template v-if="metas.license_time">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.license_time.desc }}
        </div>
        <div
          v-if="metas.license_time.value"
          class="car-meta-item-value">
          <span>{{ metas.license_time.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="metas.mileage">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.mileage.desc }}
        </div>
        <div
          v-if="metas.mileage.value"
          class="car-meta-item-value">
          <span>{{ metas.mileage.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="metas.emission">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.emission.desc }}
        </div>
        <div
          v-if="metas.emission.value"
          class="car-meta-item-value">
          <span>{{ metas.emission.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="metas.displacement">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.displacement.desc }}
        </div>
        <div
          v-if="metas.displacement.value"
          class="car-meta-item-value">
          <span>{{ metas.displacement.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="metas.transmission">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.transmission.desc }}
        </div>
        <div class="car-meta-item-value">
          <span>{{ metas.transmission.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="metas.seat_num">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.seat_num.desc }}
        </div>
        <div
          v-if="metas.seat_num.value"
          class="car-meta-item-value">
          <span>{{ metas.seat_num.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="isNewEnergy && replacingBattery">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          支持换电
        </div>
        <div class="car-meta-item-value">
          <span>{{ replacingBattery }}</span>
        </div>
      </li>
    </template>

    <template v-if="isNewEnergy && rentingBattery">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          电池租赁/买断
        </div>
        <div class="car-meta-item-value">
          <span>{{ rentingBattery }}</span>
        </div>
      </li>
    </template>

    <template v-if="threeEvWarranty">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          三电质保
        </div>
        <div class="car-meta-item-value">
          <span>{{ threeEvWarranty }}</span>
        </div>
      </li>
    </template>

    <template v-if="metas.position">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.position.desc }}
        </div>
        <div
          v-if="metas.position.value"
          class="car-meta-item-value">
          <span>{{ metas.position.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="metas.license_region">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.license_region.desc }}
        </div>
        <div
          v-if="metas.license_region.value"
          class="car-meta-item-value">
          <span>{{ metas.license_region.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="metas.road_engineer">
      <li class="car-meta-item">
        <div class="car-meta-item-key">
          {{ metas.road_engineer.desc }}
        </div>
        <div
          v-if="metas.road_engineer.value"
          class="car-meta-item-value">
          <span>{{ metas.road_engineer.value }}</span>
        </div>
      </li>
    </template>

    <template v-if="serviceProvider">
      <li
        class="car-meta-item"
        style="flex-basis: 45%;">
        <div class="car-meta-item-key">
          售前检查整备实施
        </div>
        <div class="car-meta-item-value">
          <span>{{ serviceProvider }}</span>
        </div>
      </li>
    </template>

    <template v-if="financialAccount">
      <li
        class="car-meta-item"
        style="flex-basis: 55%;">
        <div class="car-meta-item-key">
          财务账户
        </div>
        <div class="car-meta-item-value">
          <span>{{ financialAccount }}</span>
        </div>
      </li>
    </template>
  </ul>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'MetaInfo',

  computed: {
    ...mapGetters('Car', [
      'metasByCarId',
      'serviceProviderByCarId',
      'financialAccountByCarId',
      'carByCarId',
      'replacingBatteryByCarId',
      'rentingBatteryByCarId',
      'newEnergyByCarId',
      'threeEvWarrantyByCarId',
    ]),

    metas () {
      return this.metasByCarId(this.$route.params.id)
    },

    serviceProvider () {
      return this.serviceProviderByCarId(this.$route.params.id)
    },

    // financialAccount
    // - Date: 2023.09.13
    // - 财务账户
    financialAccount () {
      return this.financialAccountByCarId(this.$route.params.id)
    },

    // car
    // - 2024.08.13
    car () {
      return this.carByCarId(this.$route.params.id)
    },

    // replacingBattery
    // - 2024.08.13
    // - Replacing battery
    replacingBattery () {
      return this.replacingBatteryByCarId(this.$route.params.id)
    },

    // rentingBattery
    // - 2024.08.13
    // - Is new renting battery by car id
    rentingBattery () {
      return this.rentingBatteryByCarId(this.$route.params.id)
    },

    // isNewEnergy
    // - 2024.08.13
    // - Is new energy by car id
    isNewEnergy () {
      return this.newEnergyByCarId(this.$route.params.id)
    },

    // threeEvWarranty
    // - 2024.10.16
    // - Three EV warranty
    threeEvWarranty () {
      return this.threeEvWarrantyByCarId(this.$route.params.id)
    },
  },
}
</script>

<style lang="scss" scoped>

.car-meta-list {
  display: flex;
  flex-flow: row wrap;
  box-sizing: border-box;
}

.car-meta-item {
  flex-basis: 33.33%;
  box-sizing: border-box;
  display: flex;
  flex-flow: column nowrap;
  margin-bottom: 14px;
  line-height: 1;

  &:nth-last-child(-n + 3) {
    // margin-bottom: 0px;
  }
}

.car-meta-item-service-provider {
  flex-basis: 100%;
}

.car-meta-item-key {
  line-height: 1;
  font-size: .8rem;
  color: var(--black-secondary);
  margin-bottom: 4px;
}

.car-meta-item-value {
  line-height: 1;
}

.car-meta-item-value span {
  font-size: 1rem;
  color: #205dcd;
}

@media (min-width: 760px) {
  .car-meta-item {
    margin-bottom: 18px;
  }

  .car-meta-item-key {
    font-size: .85rem;
    margin-bottom: 6px;
  }

  .car-meta-item-value span {
    font-size: 1rem;
  }
}

@media (prefers-color-scheme: dark) {
  .car-meta-item-key {
    color: #7a7a7a;
  }

  .car-meta-item-value span {
    color: var(--black-primary);
  }
}

</style>
